import _ from 'lodash';
import Location from './appsExtendedNamespaces/appsExtendedLocation';
import Site from './appsExtendedNamespaces/appsExtendedSite';
import Window from './appsExtendedNamespaces/appsExtendedWindow';
import Events from './appsExtendedNamespaces/appsExtendedEvents';


import monitoring from './privates/monitoring';

const appsExtendedNamespaces = {
    Location,
    Site,
    Window,
    Events
};

export default _.mapValues(appsExtendedNamespaces, (namespace) => monitoring.monitorNamespace(namespace));
